<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini" label-width="80px">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="12">
              <el-form-item label="정산년월">
                <el-select v-model="form.years">
                  <el-option
                      v-for="item in combos['years']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="form.months">
                <el-option
                    v-for="item in combos['months']"
                    :key="item.value"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="8">
              <el-form-item label="제품군" label-width="60px">
                <el-select v-model="form.modelGroup" @change="onModelGroupChange" style="width: 30%;">
                  <el-option
                      v-for="item in combos['modelGroup']"
                      :key="item.value"
                      :label="item.value"
                      :value="item.key">
                  </el-option>
                </el-select>
                <el-select v-model="form.subModelGroup" style="width: 50%;">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['subModelGroup']"
                      :key="item.value"
                      :label="item.value"
                      :value="item.key">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="자재코드" label-width="70px">
                <el-input type="text" v-model="form.maker" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="지역/센터">
                <el-select v-model="form.catId" placeholder="지역/센터" @change="onCatIdChange" style="width: 30%;">
                  <el-option
                      v-for="item in combos['catId']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="form.asAgentId" @change="getSubCatIdChange" style="width: 50%;">
                  <el-option
                      v-for="item in combos['asAgentId']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                row-selection="single"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                @grid-ready="onReadyMain"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  props: {
  },
  data() {
    return {
      data: [],
      form: {
        companyId : '',
        years : this.$moment().format('YYYY'),
        months : this.$moment().format('MM'),
        yymm : '',
        maker : '',                    // 제조사
        catId : '',
        asAgentId : '',                // 지역/센터
        modelGroup: '',
        subModelGroup: ''
      },
      combos: {
        'years' : [],
        'months' : [],
        'modelGroup' : [],
        'subModelGroup' : [],
        'catId' : [],
        'asAgentId' : [],
      },
      gridStyle : 'padding-top: 20px; width: 100%;height: 650px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:false
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      columnDefs: [],
      frameworkComponent : {
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
      //modelGroup: '', /** 제품군 */
      modelGroupList: [], /** 제품군 리스트*/
      modelGroupNmList: [], /** 제품군 명칭 리스트*/
      //subModelGroup: '', /** 제품군 */
      subModelGroupList: [], /** 제품군 리스트*/
      subModelGroupShow: false,
      agentShow: false /** 지역/센터 상세정보 **/
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();

    },
    createMainColumnDefs() {
      const that = this
      this.columnDefs = [
        {headerName:'센터명', field:'gb', width:190},
        {headerName:'센터명', field:'asAgentNm', width:190},
        {headerName:'제품군', field:'itemGroupNm', width:190},
        {headerName:'대표모델', field:'useModelNm', width:190},
        {headerName:'자재코드', field:'itemCd', width:190},
        {headerName:'자재명', field:'itemNm', width:190},
        {headerName:'구분', field:'catNm', width:190},
        {headerName:'양품(기초)', field:'col0_00', width:120},
        {headerName:'불량(기초)', field:'col1_00', width:120},
        {headerName:'양품(1일)', field:'col0_01', width:110},
        {headerName:'불량(1일)', field:'col1_01', width:110},
        {headerName:'양품(2일)', field:'col0_02', width:110},
        {headerName:'불량(2일)', field:'col1_02', width:110},
        {headerName:'양품(3일)', field:'col0_03', width:110},
        {headerName:'불량(3일)', field:'col1_03', width:110},
        {headerName:'불량(4일)', field:'col1_04', width:110},
        {headerName:'양품(4일)', field:'col0_04', width:110},
        {headerName:'양품(5일)', field:'col0_05', width:110},
        {headerName:'불량(5일)', field:'col1_05', width:110},
        {headerName:'양품(6일)', field:'col0_06', width:110},
        {headerName:'불량(6일)', field:'col1_06', width:110},
        {headerName:'양품(7일)', field:'col0_07', width:110},
        {headerName:'불량(7일)', field:'col1_07', width:110},
        {headerName:'양품(8일)', field:'col0_08', width:110},
        {headerName:'불량(8일)', field:'col1_08', width:110},
        {headerName:'양품(9일)', field:'col0_09', width:110},
        {headerName:'불량(9일)', field:'col1_09', width:110},
        {headerName:'양품(10일)', field:'col0_10', width:120},
        {headerName:'불량(10일)', field:'col1_10', width:120},
        {headerName:'양품(11일)', field:'col0_11', width:120},
        {headerName:'불량(11일)', field:'col1_11', width:120},
        {headerName:'양품(12일)', field:'col0_12', width:120},
        {headerName:'불량(12일)', field:'col1_12', width:120},
        {headerName:'불량(13일)', field:'col1_13', width:120},
        {headerName:'양품(13일)', field:'col0_13', width:120},
        {headerName:'양품(14일)', field:'col0_14', width:120},
        {headerName:'불량(14일)', field:'col1_14', width:120},
        {headerName:'양품(15일)', field:'col0_15', width:120},
        {headerName:'불량(15일)', field:'col1_15', width:120},
        {headerName:'양품(16일)', field:'col0_16', width:120},
        {headerName:'불량(16일)', field:'col1_16', width:120},
        {headerName:'양품(17일)', field:'col0_17', width:120},
        {headerName:'불량(17일)', field:'col1_17', width:120},
        {headerName:'양품(18일)', field:'col0_18', width:120},
        {headerName:'불량(18일)', field:'col1_18', width:120},
        {headerName:'양품(19일)', field:'col0_19', width:120},
        {headerName:'불량(19일)', field:'col1_19', width:120},
        {headerName:'양품(20일)', field:'col0_20', width:120},
        {headerName:'불량(20일)', field:'col1_20', width:120},
        {headerName:'양품(21일)', field:'col0_21', width:120},
        {headerName:'불량(21일)', field:'col1_21', width:120},
        {headerName:'양품(22일)', field:'col0_22', width:120},
        {headerName:'불량(22일)', field:'col1_22', width:120},
        {headerName:'양품(23일)', field:'col0_23', width:120},
        {headerName:'불량(23일)', field:'col1_23', width:120},
        {headerName:'양품(24일)', field:'col0_24', width:120},
        {headerName:'불량(24일)', field:'col1_24', width:120},
        {headerName:'양품(25일)', field:'col0_25', width:120},
        {headerName:'불량(25일)', field:'col1_25', width:120},
        {headerName:'양품(26일)', field:'col0_26', width:120},
        {headerName:'불량(26일)', field:'col1_26', width:120},
        {headerName:'양품(27일)', field:'col0_27', width:120},
        {headerName:'불량(27일)', field:'col1_27', width:120},
        {headerName:'양품(28일)', field:'col0_28', width:120},
        {headerName:'불량(28일)', field:'col1_28', width:120},
        {headerName:'양품(29일)', field:'col0_29', width:120},
        {headerName:'불량(29일)', field:'col1_29', width:120},
        {headerName:'양품(30일)', field:'col0_30', width:120},
        {headerName:'불량(30일)', field:'col1_30', width:120},
        {headerName:'양품(31일)', field:'col0_31', width:120},
        {headerName:'불량(31일)', field:'col1_31', width:120},
        {headerName:'양품(계)', field:'col0_32', width:110},
        {headerName:'불량(계)', field:'col1_32', width:110},
        {headerName:'계', field:'col2_32', width:100}
      ];
    },
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    onModelGroupChange(param){
      this.form.subModelGroup = '';
      if(param === '') this.subModelGroupShow =  false;
      else{
        this.subModelGroupShow =  true
        // 제품군
        this.$http.get(`/api/codeMng/detail`, { params: {parentId: 143} })  // 제품군
            .then(response => {
              let subData = response.data.filter(x => x.catId == param);
              this.$http.get(`/api/codeMng/combo`, { params: {parentId: subData[0].catId} })
                  .then(response => {
                    this.combos['subModelGroup'] = response.data || []
                  });
            });
      }
    },
    getCombo(param, vCatId = '') {
      if(param.flag === 'INIT'){
        // 제조사
        this.$http.get(`/api/codeMng/combo`, {params: {parentId: 196}})
            .then(response => {
              this.makerList = response.data || []
              this.makerList.unshift({key:'', value:'전체'})
            });

        // 제품군 : ModelGroup, CAT_LVL(2)
        this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 143}})
            .then(response => {
              this.combos['modelGroup'] = response.data || []
              this.modelGroupList = response.data || []
              this.modelGroupList.unshift({key:'', value:'전체'})

            });

        //지역/센터 => 지역
        this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: 217} })
            .then(response => {
              this.combos['catId'] = response.data || []
            });

        this.form.asAgentId = null;
        this.form.userId = null;
        // 지역/센터 선택시 지역에 있는 상세센터
        this.$http.get(`/api/codeMng/combo`, { params: {parentId: 97} })
            .then(response => {
              this.combos['asAgentId'] = response.data || []
            }).finally(() => {
        });
      }
    },
    onCatIdChange(param){
      this.form.asAgentId = null;
      this.form.userId = null;

      if(param === '') this.agentShow =  false;
      else  this.agentShow =  true;

      // 지역 상세
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: param} })
          .then(response => {
            this.combos['asAgentId'] = response.data || []
          }).finally(() => {
      });
    },
    getSubCatIdChange(param){
      this.$store.commit('loading')
      this.form.userId = null

      this.$http.post("/api/asAgentMng/detail/agent", {
        companyId: this.$store.state.loginInfo.compCd,
        asAgentId: parseInt(param),
        userId : 0,
        useYn : 'Y',
        processTime: ""
      }).then(response => {
        response.data.map(x => {
          x.key = x.userId
          x.value = x.userNm
          return x
        })
        this.combos['userId'] = response.data
      }).finally(() => {
        this.$store.commit('finish')
      });
    },

    goOpen() {
      this.$store.commit('loading')
      const vForm = {
        yymm : this.form.years + this.form.months,
        maker : this.form.maker,                         // 제조사
        itemGroup : this.form.modelGroup,               // 제품군
        itemCd : this.form.subModelGroup,     // 제품코드
        catId : this.form.catId,                     // 지역
        asAgentId : this.form.asAgentId,                 // 센터
      }
      this.$http.post(_url("/api/workMng/dailyReceivableManager/list"), vForm)
          .then(response => {
        this.data = response.data
      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    save() {
      console.log('test',this.$parent.$refs.step.next())
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/workMng/closingManager/init`)
          .then(response => {
            this.combos['years'] = response.data.years;
            this.combos['months'] = response.data.months;
          }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
          });

      this.createMainColumnDefs();
    },
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;

    this.getCombo({flag: 'INIT'})
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>